import { ComponentEntry } from '../../core/common-types'

const entry: ComponentEntry = {
	componentType: 'tpaWidgetNative',
	loadComponent: () => import('./tpaWidgetNative' /* webpackChunkName: "tpaWidgetNative" */),
}

export default entry
